module.exports = __webpack_public_path__ + "img/recoveryIcon.d0fc3a68.svg";